import type { ButtonPropView } from '@consta/uikit/Button'
import { cnButton } from '@consta/uikit/Button'
import type { ComponentProps, PropsWithChildren } from 'react'
import { forwardRef } from 'react'

type SimpleButtonProps = ComponentProps<'button'> & {
  view: ButtonPropView
  onClick: VoidFunction
}

export const SimpleButton = forwardRef<HTMLButtonElement, PropsWithChildren<SimpleButtonProps>>(
  function SimpleButton({ view, children, onClick, ...props }, ref) {
    return (
      <button
        ref={ref}
        className={cnButton({ view, size: 'xs', onlyIcon: true })}
        type="button"
        onClick={onClick}
        {...props}>
        {children}
      </button>
    )
  },
)
